<template>
  <div
    class="calico-ai-content body--medium markdown-content"
    v-html="safeContent"
  />
</template>

<script>
import { marked } from 'marked'
import DOMPurify from 'dompurify'

export default {
  name: "CalicoAIContent",
  props: {
    content: {
      type: String,
      required: true
    }
  },
  computed: {
    safeContent() {
      const cleaned = this.message?.replace(/\*\*(.*?)\s+\*\*/g, '**$1**');
      const rawHtml = marked(cleaned || '')
      return DOMPurify.sanitize(rawHtml)
    }
  }
}
</script>

<style scoped lang="scss">
.calico-ai-content {
  :deep(p) {
    margin: 0;
    padding: 0;
  }

  :deep(.markdown-content) {
    p {
      margin: 0;
      padding: 0;
      margin-bottom: $space-small;

      &:last-child {
        margin-bottom: 0;
      }
    }

    strong {
      font-weight: $font-weight-heavy;
    }

    em, i {
      font-style: italic;
    }

    code {
      background-color: $color-neutral-light;
      padding: $space-xxsmall $space-xxsmall;
      border-radius: $border-width-default;
      font-family: monospace;
    }

    pre {
      background-color: $color-neutral-light;
      padding: $space-small;
      border-radius: $space-xxsmall;
      overflow-x: auto;
      margin: $space-small 0;
      font-family: monospace;
      white-space: pre-wrap;
    }

    table {
      width: 100%;
      border-collapse: collapse;
      margin: $space-small 0 $space-small 0;
    }

    th,
    td {
      border: 1px solid $color-neutral-light;
      padding: 8px;
      text-align: left;
    }

    th {
      background-color: $color-neutral-light;
    }

    ul, ol {
      padding-left: $space-medium;
      margin: $space-small 0;

      li {
        margin-bottom: $space-xsmall;
        line-height: 1.5;
      }
    }

    blockquote {
      border-left: $border-width-default solid $color-neutral-light;
      padding-left: $space-small;
      margin: $space-small 0;
      color: inherit;
      font-style: italic;
    }

    h1, h2, h3, h4, h5, h6 {
      margin: $space-medium 0 $space-small 0;
      font-weight: $font-weight-heavy;
    }

    a {
      text-decoration: underline;
      font-weight: $font-weight-heavy;
      
      &:hover {
        opacity: 0.8;
      }
    }

    img {
      max-width: 100%;
      height: auto;
      border-radius: $space-xxsmall;
      margin: $space-small 0;
    }

    hr {
      border: none;
      border-top: 1px solid $color-neutral-light;
      margin: $space-medium 0;
    }

    kbd {
      background-color: $color-neutral-light;
      border: 1px solid $color-neutral-light;
      color: inherit;
      display: inline-block;
      font-size: 0.9em;
      font-weight: $font-weight-heavy;
      line-height: 1;
      padding: $space-xxsmall $space-xsmall;
      white-space: nowrap;
    }

    mark {
      background-color: $color-neutral-light;
      padding: 0 $space-xxsmall;
      border-radius: $space-xxsmall;
    }

    del {
      text-decoration: line-through;
      color: $color-text-secondary;
    }

    ins {
      text-decoration: underline;
      font-weight: $font-weight-heavy;
    }
  }
 }
</style>
